export default function MeetingCardSkeleton() {
  return (
    <div className="relative flex w-full max-w-[26rem] flex-col rounded-xl bg-white bg-clip-border text-gray-700 shadow-lg mt-6 animate-pulse">
      <div
        className="relative mx-4 mt-4 overflow-hidden rounded-xl bg-gray-300"
        style={{ height: 216 }}></div>
      <div className="p-6">
        <div className="h-6 w-3/4 bg-gray-300 rounded mb-3"></div>
        <div className="h-4 w-1/2 bg-gray-300 rounded mb-3"></div>
        <div className="h-4 w-3/4 bg-gray-300 rounded mb-3"></div>
        <div className="h-6 w-6 bg-gray-300 rounded"></div>
      </div>
      <div className="p-6 pt-3">
        <div className="h-12 w-full bg-gray-300 rounded"></div>
      </div>
    </div>
  )
}
